import React from 'react';
import styles from './footer.module.scss';
import {translate} from '../../../shared/utils/localization-utils';

export default function Footer() {
	const actualYear: number = new Date().getFullYear();
	const version = process.env.REACT_APP_VERZE || 'Neznámá';

	return (
		<footer className={styles.footer}>
			<div className={styles.footerBottom}>
				<div className="copyright">
					<p>&copy; {actualYear} {translate('footer.companyName')} {translate('footer.copyright')}</p>
				</div>
				<div className="site-information">
					<p>{version} {translate('footer.aboutApplication.version')}</p>
				</div>
			</div>
		</footer>
	);
}
